const FINISH_TYPES = [
  { value: 'PLASTER', label: 'Plaster' },
  { value: 'PEBBLE', label: 'Pebble' },
  { value: 'QUARTZ', label: 'Quartz' },
];

//Plaster crews are paid one of three pool rates depending on the finish, so the breakdown records
//which one the job was. Picking a product sets it; choosing here overrides that.
const CostBreakdownFinishType = ({ value, onChange, disabled }) => {
  return (
    <div className='flex flex-col w-full gap-2 pb-3 mb-2 border-b'>
      <p className='text-sm font-semibold text-dark-blue'>Finish type</p>
      <div className='flex flex-wrap items-center gap-6'>
        {FINISH_TYPES.map(type => (
          <div key={type.value}>
            <input
              type='radio'
              id={`finishType-${type.value}`}
              name='finishType'
              className='mt-[-2px]'
              value={type.value}
              checked={value === type.value}
              disabled={disabled}
              onChange={() => onChange(type.value)}
            />
            <label
              htmlFor={`finishType-${type.value}`}
              className='text-dark-blue text-sm font-semibold ml-[10px]'
            >
              {type.label}
            </label>
          </div>
        ))}
        {!value && !disabled && (
          <p className='text-sm text-gunite-red'>Required before submitting</p>
        )}
      </div>
    </div>
  );
};

export default CostBreakdownFinishType;
